import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Fetches a server-written file and hands it to the browser as a download.
 *
 * Every table with a server export was doing this in its own component: get
 * the blob, trigger the download, flip an `exporting` flag, raise a snackbar on
 * failure. The roll-off board was about to be the fourth copy. What is worth
 * having once is the sequence; the flag and the failure message stay with the
 * page, which is why this completes rather than swallowing errors - a caller
 * that wants to say "Export failed" needs the error to reach it.
 *
 * Emits once, after the download has been handed to the browser, so a page can
 * clear its flag in `next` and report in `error` without a second subscription.
 */
export function downloadFile(
  http: HttpClient, url: string, filename: string,
): Observable<void> {
  return http.get(url, { responseType: 'blob' })
    .pipe(map(blob => triggerBlobDownload(blob, filename)));
}

export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a   = document.createElement('a');
  a.href     = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 100);
}
